import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const SUGeneralVoucherDetail = defineAsyncComponent(() =>
  import('@/views/summary/suGeneralVoucher/SUGeneralVoucherDetail.vue'),
);
const SUAccountTransferDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
//#region Phiếu kết chuyển / Quyết toán
const TransferActivityDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
const TranferClosingDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
const TranferReceiptClearDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
const TransferBudgetBalanceDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
const TranferReceiptClearInMonth13Detail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
const TransferBeginingDetail = defineAsyncComponent(() =>
  import('@/views/summary/suAccountTransfer/SUAccountTransferDetail.vue'),
);
//#endregion
const SUVoucherListDetail = defineAsyncComponent(() => import('@/views/summary/suVoucherList/SUVoucherListDetail.vue'));
const SUVoucherListPopup = defineAsyncComponent(() => import('@/views/summary/suVoucherList/SUVoucherListPopup.vue'));
const SURegisterListDetail = defineAsyncComponent(() =>
  import('@/views/summary/suRegisterVoucher/SURegisterListDetail.vue'),
);
const SURegisterListPopup = defineAsyncComponent(() =>
  import('@/views/summary/suRegisterVoucher/SURegisterListPopup.vue'),
);
const lockLedgerVoucher = defineAsyncComponent(() => import('@/views/summary/suLockLedger/LockLedgerVoucher.vue'));
const UnLockLedgerVoucher = defineAsyncComponent(() => import('@/views/summary/suLockLedger/UnLockLedgerVoucher.vue'));
const processLockLedgerVoucher = defineAsyncComponent(() =>
  import('@/views/summary/suLockLedger/ProcessLockLedgerVoucher.vue'),
);
const ChangePostedDate = defineAsyncComponent(() => import('@/views/summary/suLockLedger/changePostedDate.vue'));
const resultWriteLedger = defineAsyncComponent(() => import('@/views/summary/suLockLedger/ResultWriteLedger.vue'));
const SUSubmitReportDetail = defineAsyncComponent(() =>
  import('@/views/summary/suSubmitReport/suSubmitReportDetail/SUSubmitReportDetail.vue'),
);
const SUSubmitReportNotificationDetail = defineAsyncComponent(() =>
  import('@/views/summary/suSubmitReport/SUSubmitReportNotificationDetail.vue'),
);
const suCreateReportPopupParam = defineAsyncComponent(() =>
  import('@/views/summary/suCreateReport/SUCreateReportPopupParam.vue'),
);
const suCreateReportDetail = defineAsyncComponent(() =>
  import('@/views/summary/suCreateReport/SUCreateReportDetail.vue'),
);
const parallelVoucher = defineAsyncComponent(() =>
  import('@/views/summary/suGeneralVoucher/SUGeneralParallelVoucher.vue'),
);

export function registerSummary(app) {
  const registerConfig = {
    SUGeneralVoucherDetail: SUGeneralVoucherDetail,
    SUAccountTransferDetail: SUAccountTransferDetail,
    SUVoucherListDetail: SUVoucherListDetail,
    SUVoucherListPopup: SUVoucherListPopup,
    SURegisterListDetail: SURegisterListDetail,
    SURegisterListPopup: SURegisterListPopup,
    LockLedgerVoucher: lockLedgerVoucher,
    ChangePostedDate: ChangePostedDate,
    UnLockLedgerVoucher: UnLockLedgerVoucher,
    ProcessLockLedgerVoucher: processLockLedgerVoucher,
    ResultWriteLedger: resultWriteLedger,
    SUSubmitReportDetail: SUSubmitReportDetail,
    SUSubmitReportNotificationDetail: SUSubmitReportNotificationDetail,
    SUCreateReportPopupParam: suCreateReportPopupParam,
    SUCreateReportDetail: suCreateReportDetail,
    ParallelVoucher: parallelVoucher,
    //#region Phiếu kết chuyển / Quyết toán
    TransferActivityDetail: TransferActivityDetail,
    TranferClosingDetail: TranferClosingDetail,
    TranferReceiptClearDetail: TranferReceiptClearDetail,
    TransferBudgetBalanceDetail: TransferBudgetBalanceDetail,
    TranferReceiptClearInMonth13Detail: TranferReceiptClearInMonth13Detail,
    TransferBeginingDetail: TransferBeginingDetail,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Summary');
}
